import * as yup from 'yup';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const DATE_FORMAT = 'YYYY-MM-DD';

const isValidDocumentDateFormat = (value: string): boolean => {
  const parsedDate = dayjs(value, DATE_FORMAT, true);

  return parsedDate.isValid();
};

const isNotFutureDocumentDate = (value: string): boolean => {
  const parsedDate = dayjs(value, DATE_FORMAT, true);

  return !parsedDate.isAfter(dayjs(), 'day');
};

export interface SimplifiedExpenseInvoiceFormData {
  companyId: number | null;
  issueDate: string;
  totalGross: number | null;
  currency: string;
  description: string;
  tagIds: number[];
}

export const simplifiedExpenseInvoiceSchema: yup.ObjectSchema<SimplifiedExpenseInvoiceFormData> = yup.object({
  companyId: yup
    .number()
    .typeError('Firma jest wymagana')
    .required('Firma jest wymagana')
    .integer('Firma jest wymagana')
    .moreThan(0, 'Firma jest wymagana'),
  issueDate: yup
    .string()
    .required('Data dokumentu jest wymagana')
    .test('valid-format', 'Nieprawidłowy format daty dokumentu', (value) => {
      if (!value) {
        return true;
      }

      return isValidDocumentDateFormat(value);
    })
    .test('not-future', 'Data dokumentu nie może być w przyszłości', (value) => {
      if (!value || !isValidDocumentDateFormat(value)) {
        return true;
      }

      return isNotFutureDocumentDate(value);
    }),
  totalGross: yup
    .number()
    .typeError('Kwota brutto musi być liczbą')
    .required('Kwota brutto jest wymagana')
    .moreThan(0, 'Kwota brutto musi być większa niż 0'),
  currency: yup
    .string()
    .required('Waluta jest wymagana')
    .oneOf(
      [
        'PLN',
        'ALL', 'AMD', 'AZN', 'BAM', 'BGN', 'BYN', 'CHF', 'CZK', 'DKK',
        'GEL', 'HUF', 'ISK', 'MDL', 'MKD', 'NOK', 'RON', 'RSD', 'RUB', 'SEK', 'UAH',
        'EUR',
        'DZD', 'EGP', 'LYD', 'MAD', 'TND',
        'TRY',
        'GBP', 'USD',
      ],
      'Nieprawidłowa waluta'
    ),
  description: yup
    .string()
    .required('Opis kosztu jest wymagany')
    .trim()
    .max(1000, 'Opis nie może przekraczać 1000 znaków'),
  tagIds: yup
    .array()
    .typeError('Tagi muszą mieć poprawny format')
    .transform((value, originalValue) => (originalValue == null ? [] : value))
    .of(yup.number().integer().required())
    .default([]),
});
